import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

import { Scrollbars } from 'react-custom-scrollbars';

var CurrentUser = require("lib/account/CurrentUser");
var BookGrid = require("components/reading/shelves/BookGrid");
var BookSidebar = require("components/reading/shelves/BookSidebar");
var ExpandedBookDetails = require("components/reading/shelves/ExpandedBookDetails");

var ButtonDropdownOption = require("components/utility/ButtonDropdownOption");
var ButtonDropdown = require("components/utility/ButtonDropdown");
var DisplayToggleControl = require("components/utility/DisplayToggleControl");
var EmptyStateContainer = require("components/utility/EmptyStateContainer");
var Spinner = require("components/utility/Spinner");
var Glyphicon = require("components/utility/icons/Glyphicon");

var ArbitrarySubjects = require("lib/data/ArbitrarySubjects");
var Features = require('lib/account/Features');

var WritingSelectors = require("lib/selectors/WritingSelectors");

var ReadingActions = require("lib/actions/ReadingActions");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");

require("reading/shelves/book_shelf.scss");

@connect(
	(state, props) => {
		var textID = props.textID;

		if (props.classView) {
			var books = ReadingSelectors.books({ state, conditions: {
				userIDs: props.studentIDs
			}});

		} else {
			var userID = CurrentUser.get().id;

			var books = ReadingSelectors.books({ state, conditions: {
				userID
			}});

			if (textID) {
				var draftQuizzes = WritingSelectors.quizzes({
					state, conditions: { textID, userID }, filters: { draft: true }
				});
				var draftAnswers = WritingSelectors.nonQuizAnswers({
					state, conditions: { textID, userID }, filters: { draft: true }
				});
				var draftReviews = WritingSelectors.reviews({
					state, conditions: { textID, userID }, filters: { draft: true }
				});
				var draftResponses = WritingSelectors.responses({
					state, conditions: { textID, userID }, filters: { draft: true }
				});
				var draftQuestionBuilders = WritingSelectors.metaCognitiveAnswers({
					state, conditions: { textID, userID }, filters: { draft: true }
				});
				var draftCount = draftQuizzes.length + draftAnswers.length + 
					draftReviews.length + draftResponses.length + draftQuestionBuilders.length;
			}
		}

		var loading = ReadingSelectors.isLoadingBooks({ state });

		return {
			books, loading, draftCount
		};
	},

	(dispatch, props) => ({
		populateData: () => {
			if (props.classView) {
				var conditions = {
					userIDs: props.studentIDs,
					order: "desc-popularity"
				}
				return dispatch(ReadingActions.fetchBookActivity({
					conditions,
					fetchDetails: true, 
					cache: true
				}));

			} else {
				var filters = {
					user_id: CurrentUser.get().id,
					order: "desc-last-active",
					draft: true,
				}
				var embeds = ["book.quiz_user_ids", "book.quiz_draft_user_ids"];

				return dispatch(ReadingActions.fetchBookActivity({
					filters, embeds,
					fetchDetails: true, 
					cache: true
				}));


			}
		}
	})
)
@providePopulateData({ waitForLoad: true })
class BookShelf extends React.Component {

	constructor(props) {
		super();
		autobind(this);
		
		LuckyOrangeClient.tagComponent("BookShelf");
		this.state = { 
			bookDetails: {},

			// Stuff for scrolling (which is a real headache btw.)
			maxHeightSidebar: 0, maxHeightDetails: 0,
			minHeightExpanded: 0, minShelfHeight: 0
		};
	}

	isExpandedView() {
		return !!this.props.textID;
	}

	unexpandBook(e) {
		$wr.nope(e)
		this.props.switchView({ textID: undefined });
	}
	expandBook(textID) {
		if (this.props.classView) {
			var detailsView = this.props.detailsView || 
				ArbitrarySubjects.asCollection(ArbitrarySubjects.CLASS_BOOK);
		} else {
			var detailsView = this.props.detailsView || 
				ArbitrarySubjects.asCollection(ArbitrarySubjects.QUIZ_ANSWER);			
		}
		this.props.switchView({
			detailsView, textID
		});
		$wr.setWindowY(0)
	}

	onBookDetailsViewChange(detailsViewKey) {
		this.props.switchView({ detailsView: detailsViewKey });
	}
	onHeightUpdated(height) {
		if (height < this.state.maxHeightSidebar) {
			this.setState({minShelfHeight: this.state.maxHeightSidebar + 70})
		} else {
			this.setState({minShelfHeight: height + 70})
		}
		
	}
	renderExpandedView() {

		if (!this.props.classView) {
			var toggleOptions = [
				{ key: ArbitrarySubjects.asCollection(ArbitrarySubjects.QUIZ_ANSWER), text: "Quiz" },
				{ key: ArbitrarySubjects.asCollection(ArbitrarySubjects.ANSWER), text: "Practice Questions" }, 
				{ key: ArbitrarySubjects.asCollection(ArbitrarySubjects.REVIEW), text: "Reviews" },
				{ key: ArbitrarySubjects.asCollection(ArbitrarySubjects.QUESTION_BUILDER), text: "Question Builders"}
			];				
			if (Features.isEnabled(Features.DIGITAL_EXERCISES)) {
				var exercisesKey = { key: ArbitrarySubjects.asCollection(ArbitrarySubjects.EXERCISE), text: "Exercises" };
				toggleOptions.push(exercisesKey);
			}
			// add unfinsihed work option if drafts exist
			if (this.props.draftCount > 0) {
				var draftToggleText = "Unfinished Work (" + this.props.draftCount + ")";
				toggleOptions.push({ key: ArbitrarySubjects.asCollection(ArbitrarySubjects.DRAFT), text: draftToggleText });
			}
			// show text for current view on dropdown
			var currentDetailViewObj = _.findWhere(toggleOptions, { key: this.props.detailsView })
			if (currentDetailViewObj && currentDetailViewObj.text) {
				var firstOptionText = currentDetailViewObj.text
			} else {
				var firstOptionText = 'Quiz'
			}
			// display dropdown
			var displayToggleOptions = _.map(toggleOptions, (option) => {
				return (
					<ButtonDropdownOption text={option.text}
						onClick={this.onBookDetailsViewChange.bind(this, option.key)} />
				)
			})

			var displayToggleOptions = (
				<div className='toggleOptionContainer'>
					<ButtonDropdown text={firstOptionText} dropdownDisplay="link" className="hideOnPrint smallObject">
						{ displayToggleOptions }
					</ButtonDropdown>
				</div>
			);
		}

		if (this.isExpandedView()) {
			var expandedKey = this.props.textID + "::" + this.props.detailsView;
			if (this.props.classView) {
				var expandedContent = (
					<div>
						<Scrollbars autoHeight id="bookDetailFrame" className="bookDetailFrame" autoHeightMin={ 0 }
							autoHeightMax={ this.state.maxHeightDetails }>
							<ExpandedBookDetails key={ expandedKey }
								textID={ this.props.textID } 
								studentIDs={ this.props.studentIDs }
								view={ this.props.detailsView } />
						</Scrollbars>
					</div>
				);	
			} else if (this.props.detailsView == "quizzes" || this.props.detailsView == "answers") {
				var expandedContent = (
					<ExpandedBookDetails key={ expandedKey }
						onHeightUpdated={ this.onHeightUpdated }
						textID={ this.props.textID } 
						view={ this.props.detailsView } />
				);	
			} else {
				var expandedContent = (
					<div>
						<Scrollbars autoHeight id="bookDetailFrame" className="bookDetailFrame" autoHeightMin={ 0 }
							autoHeightMax={ this.state.maxHeightDetails }>
							<ExpandedBookDetails key={ expandedKey }
								textID={ this.props.textID } 
								view={ this.props.detailsView } />
						</Scrollbars>
					</div>
				);	
			}		
		}

		return (
			<div className="clearfix">

				<div className="hideOnPrint">
					<div className="sidebarWrap">

						<div className="backLink">
							<a href="#" onClick={ this.unexpandBook }>
								<Glyphicon icon="chevron-left" /> Back
							</a>
						</div>
						<div ref="sidebarWrap">
							<Scrollbars autoHeight ref="scrollbars"
								autoHeightMin={ 0 } autoHeightMax={ this.state.maxHeightSidebar }>

								<BookSidebar books={_.filter(this.props.books, (book) => book.text_id !== '' && book.text_id !== 'MISSING_TEXT_ID') } selectedTextID={ this.props.textID }
									onBookSelect={ this.expandBook } />
							</Scrollbars>
						</div>
					</div>
				</div>
				
				<div className="detailsWrap">
					{ displayToggleOptions }
					<div ref="detailsWrap">
						{ expandedContent }
					</div>
				</div>
			</div>
		);
	}

	renderGridEmptyState() {
		if (this.props.classView) {
			if (CurrentUser.isAdmin()) {
				var emptyStatusText = "Once your students start reading, their books and book reviews will appear here."
			} else {
				var emptyStatusText = "Once you and your classmates read some books, your books will appear here."
			}
			var emptyImagePath = require("empty-state/class-shelf.png");

		} else {
			var emptyStatusText = "Once you do some activities and complete some quizzes, your books will appear here."
			var emptyImagePath = require("empty-state/my-shelf.png");					
		}

		return (
			<EmptyStateContainer statusText={ emptyStatusText } imagePath={ emptyImagePath } />
		);
	}

	renderGridView() {
		if (!this.props.loading && _.isEmpty(this.props.books)) {
			return (
				this.renderGridEmptyState()
			);
		}

		if (this.props.classView) {
			var showStudentIDs = this.props.studentIDs;
		}

		return (
			<BookGrid books={_.filter(this.props.books, (book) => book.text_id !== '' && book.text_id !== 'MISSING_TEXT_ID') }
				showQuizIcons={ !this.props.classView }
				showStudentIDs={ showStudentIDs }
				onBookSelect={ this.expandBook } loading={ this.props.loading } />
		);
	}

	render() {

		if (this.isExpandedView()) {
			var viewToggleClassName = "viewToggle expanded";
			var gridStyle = { maxHeight: this.state.minHeightExpanded };
			var shelfStyle = {height: this.state.minShelfHeight}
		} else {
			var viewToggleClassName = "viewToggle grid";
		}

		return (
			<div className="container bookShelf" style={ shelfStyle }>
				<div className={ viewToggleClassName }>
					<div className="gridWrap hideOnPrint" style={ gridStyle } ref="gridWrap">
						{ this.renderGridView() }
					</div>

					<div className="expandedWrap">
						{ this.renderExpandedView() }
					</div>
				</div>
			</div>
		)
	}

	initSideBars() {
		if (!this.refs.detailsWrap || !this.refs.sidebarWrap) {
			setTimeout(this.initSideBars, 300);
		} else {
			var maxHeightDetails = window.innerHeight - $(this.refs.detailsWrap).offset().top - 30;
			var maxHeightSidebar = window.innerHeight - $(this.refs.sidebarWrap).offset().top - 30;
			var minHeightExpanded = window.innerHeight - $(this.refs.gridWrap).offset().top;
			
			// DISPLAY QUIZZES FULLY TO ALLOW PRINTING
			if (this.props.detailsView == "quizzes" || this.props.detailsView == "answers") {
				if (this.state.minShelfHeight > 0) {
					var minShelfHeight = this.state.minShelfHeight
				} else {
					var minShelfHeight = 0;
				}
			} else {
				var minShelfHeight = minHeightExpanded
			}

			// Kinda arbitrary but ok
			minShelfHeight = Math.max(minShelfHeight, $(this.refs.detailsWrap).height() + 100)

			this.setState({ maxHeightSidebar: maxHeightSidebar, maxHeightDetails: maxHeightDetails,
				minHeightExpanded: minHeightExpanded, minShelfHeight: minShelfHeight });
		}
	}

	scrollToBook() {
		var uniqueClass = ".book" + this.props.textID;
		var $book = $(this.refs.sidebarWrap).find(uniqueClass);
		if ($book.length > 0) {
			var bookY = $book.position().top;
			var scrollY = this.refs.scrollbars.getScrollTop();
			var scrollPosition = bookY + scrollY;
			this.refs.scrollbars.scrollTop(scrollPosition);			
		}
	}

	componentDidUpdate(prevProps) {
		var textID = this.props.textID;
		if (textID && (textID != prevProps.textID)) {
			this.scrollToBook();
		}
		// if we switch away from draft view to a book with no drafts, switch off draft view
		if (this.props.detailsView == ArbitrarySubjects.asCollection(ArbitrarySubjects.DRAFT) && this.props.draftCount == 0 && !this.props.loading){
			this.onBookDetailsViewChange(ArbitrarySubjects.asCollection(ArbitrarySubjects.QUIZ_ANSWER))
		}
	}

	componentDidMount() {
		$(window).on("resize", this.initSideBars);
		this.initSideBars();
	}

	componentWillUnmount() {
		$(window).off("resize", this.initSideBars);
	}

}

BookShelf.WrappedComponent.propTypes = StrictPropTypes({
	// From component above
	detailsView: PropTypes.string,
	textID: PropTypes.string,
	studentIDs: PropTypes.array,
	// Too much of a headache to not pass this in... but I'm not happy about it.
	// Generally better to pass in more descriptive individual props
	classView: PropTypes.bool,

	// handler from component above
	switchView: PropTypes.func.isRequired,

	// @connect data
	loading: PropTypes.bool,
	books: PropTypes.array,
	draftCount: PropTypes.number,

	// @connect handler
	populateData: PropTypes.func,
});

module.exports = BookShelf;


// WEBPACK FOOTER //
// ./modules/components/reading/shelves/BookShelf.js